import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import ZhuyinLesson from 'components/ZhuyinLesson';

export const ZhuyinLessonModalComponent = ({ zhuyinLessonResource }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.ZhuyinLesson}>
    <ZhuyinLesson resource={zhuyinLessonResource} />
  </ExtendedContentContainer>
};